// extracted by mini-css-extract-plugin
export default {"navigationsWrapper":"_Navigations_navigationsWrapper__dJ7kf","navigations_item":"_Navigations_navigations_item__vaTnU"};